module.exports = __webpack_public_path__ + "img/newpagebg2.7c89840b.jpg";